/**
 * Sends the browser to another site: a Stripe page, the app from the site,
 * the site from the app. Its own module so a test can watch it.
 */
export function goTo(url: string): void {
    window.location.assign(url);
}

/** As {@link goTo}, in place of this page in the history, so Back skips it. */
export function replaceWith(url: string): void {
    window.location.replace(url);
}
